import React from 'react';

import './App.css';
import { AuthProvider } from './helper/AuthProvider';
import AppRoute from './AppRoute';
import { ToastProvider } from './helper/ToastProvider';

const App = () => {
  return (
    <ToastProvider>
      <AuthProvider>
        <AppRoute />
      </AuthProvider>
    </ToastProvider>
  );
};

export default App;
